export const GridFilterReferenceTypes = {
  ADD_ON_CHARGE: "ADD_ON_CHARGE_GRID_FILTERS",
  ASSET: "ASSET_GRID_FILTERS",
  ASSET_EXPENSE: "ASSET_EXPENSE_GRID_FILTERS",
  CALL_AGENT_NOTES: "CALL_AGENT_NOTES_GRID_FILTERS",
  CLAIM: "CLAIM_GRID_FILTERS",
  CONTRACT: "CONTRACT_GRID_FILTERS",
  CONTRACT_INSURANCE: "CONTRACT_INSURANCE_GRID_FILTERS",
  CURRENCY_RATE: "CURRENCY_RATE_GRID_FILTERS",
  CUSTOMER: "CUSTOMER_GRID_FILTERS",
  DRIVER: "DRIVER_GRID_FILTERS",
  DRIVER_SELECTION: "DRIVER_SELECTION_GRID_FILTERS",
  EMAIL_LOADER_LOG: "EMAIL_LOADER_LOG_GRID_FILTERS",
  EXPENSE: "EXPENSE_GRID_FILTERS",
  FUEL_PRICE: "FUEL_PRICE_GRID_FILTERS",
  INSURANCE: "INSURANCE_GRID_FILTERS",
  INVOICE: "INVOICE_GRID_FILTERS",
  LOCATION: "LOCATION_GRID_FILTERS",
  MODULE_CC_EMAILS: "MODULE_CC_EMAILS_GRID_FILTERS",
  OFFENSE_TYPE: "OFFENSE_TYPE_GRID_FILTERS",
  PAYMENT_METHOD_TYPE: "PAYMENT_METHOD_TYPE_GRID_FILTERS",
  PROMOTION: "PROMOTION_GRID_FILTERS",
  RATE_NAME: "RATE_NAME_GRID_FILTERS",
  RATE_PLAN: "RATE_PLAN_GRID_FILTERS",
  REFERRAL: "REFERRAL_GRID_FILTERS",
  RESERVATION: "RESERVATION_GRID_FILTERS",
  ROLE: "ROLE_GRID_FILTERS",
  SOURCE: "SOURCE_GRID_FILTERS",
  TAX: "TAX_GRID_FILTERS",
  TERMS_AND_CONDITION: "TERMS_AND_CONDITION_GRID_FILTERS",
  USER: "USER_GRID_FILTERS",
  VEHICLE_MAINTENANCE_HISTORY: "VEHICLE_MAINTENANCE_HISTORY_GRID_FILTERS",
  VEHICLE_MAINTENANCE_SCHEDULE:
    "VEHICLE_MAINTENANCE_SCHEDULE_GRID_FILTERS",
  VEHICLE_TRACK: "VEHICLE_TRACK_GRID_FILTERS",
  VEHICLE_MAKE: "VEHICLE_MAKE_GRID_FILTERS",
  VEHICLE_MODEL: "VEHICLE_MODEL_GRID_FILTERS",
  VEHICLE_TYPE: "VEHICLE_TYPE_GRID_FILTERS",
  RESERVATION_INVOICE: "RESERVATION_INVOICE_GRID_FILTERS",
  VENDOR: "VENDOR_GRID_FILTERS",
} as const;

const gridFilterReferenceTypeByModule: Record<string, string> = {
  addoncharge: GridFilterReferenceTypes.ADD_ON_CHARGE,
  asset: GridFilterReferenceTypes.ASSET,
  booking: GridFilterReferenceTypes.EMAIL_LOADER_LOG,
  claim: GridFilterReferenceTypes.CLAIM,
  contract: GridFilterReferenceTypes.CONTRACT,
  currencyrate: GridFilterReferenceTypes.CURRENCY_RATE,
  customer: GridFilterReferenceTypes.CUSTOMER,
  driver: GridFilterReferenceTypes.DRIVER,
  driverselection: GridFilterReferenceTypes.DRIVER_SELECTION,
  expense: GridFilterReferenceTypes.EXPENSE,
  fuelprice: GridFilterReferenceTypes.FUEL_PRICE,
  insurance: GridFilterReferenceTypes.INSURANCE,
  invoice: GridFilterReferenceTypes.INVOICE,
  location: GridFilterReferenceTypes.LOCATION,
  moduleccemails: GridFilterReferenceTypes.MODULE_CC_EMAILS,
  offensetype: GridFilterReferenceTypes.OFFENSE_TYPE,
  paymentmethodtype: GridFilterReferenceTypes.PAYMENT_METHOD_TYPE,
  promotion: GridFilterReferenceTypes.PROMOTION,
  ratename: GridFilterReferenceTypes.RATE_NAME,
  rateplan: GridFilterReferenceTypes.RATE_PLAN,
  referral: GridFilterReferenceTypes.REFERRAL,
  reservation: GridFilterReferenceTypes.RESERVATION,
  retell: GridFilterReferenceTypes.CALL_AGENT_NOTES,
  role: GridFilterReferenceTypes.ROLE,
  source: GridFilterReferenceTypes.SOURCE,
  tax: GridFilterReferenceTypes.TAX,
  termsandcondition: GridFilterReferenceTypes.TERMS_AND_CONDITION,
  user: GridFilterReferenceTypes.USER,
  vehiclemaintenancehistory:
    GridFilterReferenceTypes.VEHICLE_MAINTENANCE_HISTORY,
  vehiclemaintenanceschedule:
    GridFilterReferenceTypes.VEHICLE_MAINTENANCE_SCHEDULE,
  vehiclemake: GridFilterReferenceTypes.VEHICLE_MAKE,
  "vehicle-track": GridFilterReferenceTypes.VEHICLE_TRACK,
  vendor: GridFilterReferenceTypes.VENDOR,
};

const normalizeReferenceKey = (value?: string) =>
  (value || "").replace(/[^a-zA-Z0-9-]/g, "").toLowerCase();

const toReferenceType = (value?: string) =>
  (value || "")
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
    .replace(/[^a-zA-Z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .toUpperCase();

export const getGridFilterReferenceType = (
  module?: string,
  fallback?: string,
) => {
  const normalizedModule = normalizeReferenceKey(module);
  const referenceType = gridFilterReferenceTypeByModule[normalizedModule];

  if (referenceType) {
    return referenceType;
  }

  const fallbackReferenceType = toReferenceType(
    module || fallback || "DEFAULT",
  );

  return `${fallbackReferenceType || "DEFAULT"}_GRID_FILTERS`;
};
